import styles from './titularArrendatarioDadosDeclaracao.module.scss';
import { isCPForCNPJ } from '../../../../utils/formatCNPJOrCPF';
import TitularArrendatarioFiliais from '../titularArrendatarioFiliais/titularArrendatarioFiliais';
import TitularArrendatarioJudicial from '../titularArrendatarioJudicial/titularArrendatarioJudicial';
import { useContext, useEffect } from 'react';
import { DiefCfemContext } from '../../../../contexts/DiefCfemContext';
import { useAuth } from 'react-oidc-context';
import { useBackEndRequests } from '../../lib/backEndRequests';
import { BrLoading } from '@govbr-ds/react-components';
import ErrorMessage from '../../../../components/errorMessage/errorMessage';
import { useQuery } from '@tanstack/react-query';
import { IDeclaracaoTitularOuArrendatario } from '../../../../interfaces/IDeclaracoes';
import { useNavigate } from 'react-router-dom';
import { IErrorWithSentryId } from 'interfaces/IErrorWithSentryId';

interface ITitularArrendatarioPassoInicialProps {
  cpfCnpj: string | null;
  declaracaoId: string;
}

const TitularArrendatarioDadosDeclaracao = ({ cpfCnpj, declaracaoId }: ITitularArrendatarioPassoInicialProps) => {
  const { getDeclaracaoById } = useBackEndRequests();

  const context = useContext(DiefCfemContext);
  const auth = useAuth();

  const navigate = useNavigate();

  const {
    data: declaracaoTitularArrendatarioData,
    isLoading: isDeclaracaoTitularArrendatarioDataLoading,
    error: declaracaoTitularArrendatarioDataError,
  } = useQuery<IDeclaracaoTitularOuArrendatario, IErrorWithSentryId>({
    queryKey: ['declaracaoTitularArrendatarioQuery', declaracaoId],
    queryFn: async () => await getDeclaracaoById(declaracaoId || ''),
    retryDelay: 100,
  });

  useEffect(() => {
    if (declaracaoTitularArrendatarioData && !isDeclaracaoTitularArrendatarioDataLoading) {
      context?.setDeclaracaoTitularArrendatario(declaracaoTitularArrendatarioData);
    }
  }, [declaracaoTitularArrendatarioData, isDeclaracaoTitularArrendatarioDataLoading, context]);

  const content = () => {
    if (isDeclaracaoTitularArrendatarioDataLoading) {
      return (
        <div className={styles.passoInicialContainer}>
          <div className={styles.screenLoading}>
            <BrLoading large label='Carregando...' />
          </div>
        </div>
      );
    }
    if (declaracaoTitularArrendatarioDataError && !declaracaoTitularArrendatarioData) {
      return (
        <ErrorMessage
          errorTitle='Erro ao carregar declaração'
          errorMessage='Não foi possível carregar a declaração. Por favor, tente novamente mais tarde.'
          errorDescription={declaracaoTitularArrendatarioDataError?.message || ''}
          error={declaracaoTitularArrendatarioDataError}
          onClickFunction={() => navigate(0)}
        />
      );
    } else {
      return (
        <div className={styles.passoInicialContainer}>
          <>
            {cpfCnpj && isCPForCNPJ(cpfCnpj) === 'CNPJ' && (
              <TitularArrendatarioFiliais declaracaoId={declaracaoId} cnpjMatriz={cpfCnpj} />
            )}
            <TitularArrendatarioJudicial declaracaoId={declaracaoId} />
          </>
        </div>
      );
    }
  };

  return content();
};

export default TitularArrendatarioDadosDeclaracao;
